<template>
  <div class="documents-details">
    <div v-if="details.headline" class="headline">{{ details.headline }}</div>
    <div v-if="details.description" class="description">{{ details.description }}</div>
  </div>
</template>

<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';

const { t } = useI18n();

const details = computed(() => ({
  headline: t('author.mediaSearch'),
  description: t('author.mediaSearchDescription'),
}));
</script>

<style lang="scss" scoped>
.documents-details {
  display: flex;
  flex-direction: column;
  gap: $bb-spacing-1;

  .headline {
    @include bb-titles-styles('xs');
  }

  .description {
    @include bb-regular-text-styles('sm');
    color: $bb-neutral-2;
  }
}
</style>
